import React from "react";
import MUILink from "@mui/material/Link";
import { DarkModeIcon, LightModeIcon } from "../../icons";
import IconButton from "../IconButton/IconButton";
import ReversingLabsLogo from "../ReversingLabsLogo/ReversingLabsLogo";
import styles from "./reportBanner.module.scss";
function ReportBanner({ children, actions, themeToggle, }) {
    const nextMode = (themeToggle === null || themeToggle === void 0 ? void 0 : themeToggle.mode) === "dark" ? "light" : "dark";
    return (React.createElement("div", { className: styles.banner },
        React.createElement("div", { className: styles["rl-logo-container"] },
            React.createElement(ReversingLabsLogo, { className: styles["rl-logo"] }),
            React.createElement(MUILink, { className: styles["rl-link"], href: "https://www.reversinglabs.com", title: "ReversingLabs website", target: "_blank" }, "TRUST DELIVERED")),
        React.createElement("div", { className: styles.content }, children),
        React.createElement("div", { className: styles.actions },
            actions,
            themeToggle && (React.createElement(IconButton, { tooltipTitle: `Switch to ${nextMode} theme`, className: styles["theme-toggle"], onClick: () => themeToggle.onToggle() }, themeToggle.mode === "dark" ? React.createElement(LightModeIcon, null) : React.createElement(DarkModeIcon, null))))));
}
export default ReportBanner;
//# sourceMappingURL=ReportBanner.js.map